module.exports = __webpack_public_path__ + "img/not-found-icon.41ae1679.svg";